import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Skeleton from "react-loading-skeleton";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    fetchedProducts: state.rootReducer.fetchedProducts || {},
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class ProductBump extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initButton = (preview) => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;
    const settings = this.props?.settings;

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");
    const priceSettings = settings["price_color"];
    const oldPriceColor = settings["old_price_color"];

    let bumpProducts = [];

    Object.keys(this.props.fetchedProducts)
      .slice(0, 2)
      .map((id_product, key) => {
        const product = this.props.fetchedProducts[id_product];

        bumpProducts.push({
          name: product.name,
          image: product.image,
          price: product.price,
        });
      });

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div
              className="product fptbox bump_outer_c_sec"
              style={cssSettingsText}
            >
              <div className="bump_c_sec">
                {(bumpProducts.length > 0 &&
                  bumpProducts.map((product, index) => (
                    <div key={index} className="bump_c_sec_li">
                      <div className="bump_p_input">
                        <input type="checkbox" className="bump_product" />
                        <label className="bump_product_label">
                          <span></span>
                        </label>
                      </div>
                      <div className="fptprice">
                        <span className="bump_c_img">
                          <a href="#">
                            <img
                              src={product.image}
                              alt="product"
                              style={{ width: 40, height: 40 }}
                            />
                          </a>
                        </span>
                        <span className="bump_p_name">
                          <a href="#0">
                            {product.name.substring(0, 16) +
                              (product.name.length > 16 ? "..." : "")}
                          </a>
                        </span>
                        <span className="bump_p_price" style={priceSettings}>
                          {product.price["old-price"] !== "" && (
                            <span className="old-price" style={oldPriceColor}>
                              {product.price["old-price"]}
                            </span>
                          )}
                          {product.price["reduced-price"]}
                        </span>
                      </div>
                      <div className="selectbox">
                        <select
                          className="form-control no-print bump-product-varient"
                          style={{ width: "auto", margin: "5px 0" }}
                        >
                          <option>Variation</option>
                        </select>
                      </div>
                    </div>
                  ))) ||
                  (!preview && (
                    <div className="bump_c_sec_li">
                      <div className="bump_p_input">
                        <Skeleton width={20} height={20} />
                      </div>
                      <div className="fptprice">
                        <span className="bump_c_img bump_skeleton_image">
                          <Skeleton width={50} height={50} />
                        </span>
                        <span className="bump_p_name">
                          <Skeleton width={100} height={26} />
                        </span>
                        <span className="bump_p_price">
                          <span className="old-price">
                            <Skeleton width={50} height={26} />
                          </span>
                          <Skeleton width={50} height={26} />
                        </span>
                      </div>
                      <div className="selectbox">
                        <Skeleton width={200} height={40} />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initButton(true)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initButton()}
      </Draggable>
    );
  }
}

ProductBump.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductBump);
